// src/pages/EditProduct.js

import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import ProductForm from "../components/ProductForm"; 

console.log("Debug: [EditProduct] after import =>", ProductForm);


const API_BASE_URL = "https://nzpdp-traceability-system-production-c63a.up.railway.app";

const EditProduct = () => {
  console.log("Debug: [EditProduct] component start.");
  
  const { productCode } = useParams();
  const navigate = useNavigate();
  const [productData, setProductData] = useState(null);

  useEffect(() => {
    console.log("Debug: [EditProduct] useEffect => fetching product:", productCode);

    axios
      .get(`${API_BASE_URL}/api/admin/products/${productCode}`)
      .then((response) => {
        console.log("Debug: [EditProduct] /GET product response =", response.data);
        setProductData(response.data);
      })
      .catch((error) => {
        console.error(
          "[EditProduct] Error fetching product:",
          error.response ? error.response.data : error.message
        );
      });
  }, [productCode]);

  const handleSubmit = (event, updatedProductData) => {
    event.preventDefault();
    console.log("Debug: [EditProduct] handleSubmit => updatedProductData:", updatedProductData);

    axios
      .put(`${API_BASE_URL}/api/admin/edit-product/${productCode}`, updatedProductData)
      .then(() => {
        alert("Product updated successfully!");
        navigate("/admin/products");
      })
      .catch((error) => {
        console.error("Error updating product:", error.response || error);
        alert(
          "Error updating product: " +
            (error.response?.data?.error || "Unknown error")
        );
      });
  };

  if (!productData) {
    console.log("Debug: [EditProduct] productData is null => showing Loading...");
    return <p>Loading...</p>;
  }

  console.log("Debug: [EditProduct] Ready to render ProductForm with productData:", productData);

  return (
    <div>
      <h3>Edit Product</h3>
 
      <ProductForm initialData={productData} onSubmit={handleSubmit} />
    </div>
  );
};

export default EditProduct;
